export const getHighResTwitterPic = (pictureUrl: string | undefined): string | undefined => {
  if (!pictureUrl?.includes('pbs.twimg.com')) {
    return pictureUrl;
  }

  return pictureUrl.replace('_normal', '');
};
